var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radius-box"},[_c('div',{staticClass:"example-box"},[_c('div',{staticClass:"example",style:({
        'border-radius': `${_vm.radius}px`,
      })})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-box"},[_c('div',{staticClass:"border-top-left-radius"}),_c('div',{staticClass:"border-top-right-radius"}),_c('div',{staticClass:"border-bottom-left-radius"}),_c('div',{staticClass:"border-bottom-right-radius"})])
}]

export { render, staticRenderFns }